import { render, staticRenderFns } from "./BaseComponent.vue?vue&type=template&id=6b40b91f&"
import script from "./BaseComponent.vue?vue&type=script&lang=js&"
export * from "./BaseComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports